export const postponingEnabled = process.env.EXPO_PUBLIC_ORDER_POSTPONING_ENABLED === 'true'
